import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { StoreItemResponse } from '../../types';
import { CreateTicketRequest, TicketResponse, TicketsType } from './types';

const useCreateTicket = <T extends TicketsType>({ ticketsType }: { ticketsType: T }) => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const createTicket = async ({ causeId, ticket, eventId }: CreateTicketRequest<T>) => {
    const { data } = await StoreApi.post<StoreItemResponse<TicketResponse<T>>>(
      `/store_items/events/${eventId}/${ticketsType}`,
      { cause_id: causeId, store_item: ticket, store_item_id: eventId }
    );
    return data.store_item;
  };

  return useMutation({
    mutationFn: createTicket,
    onSuccess: (_, variables) => {
      const { eventId, causeId } = variables;
      const tickets = ticketsType === 'tickets' ? 'tickets' : 'seasonPasses';
      void queryClient.invalidateQueries({
        queryKey: storeKeys.id(causeId).items.events.id(eventId)[tickets].all,
      });
    },
  });
};

export { useCreateTicket };
